// LanguageContext.js

import { createContext, useContext, useState, useEffect } from "react";
import * as api from "../../api/api";
import { useMsal } from "@azure/msal-react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { accounts, inProgress } = useMsal();
  const isAuthenticated = accounts.length > 0;

  const [language, setLanguage] = useState("en");

  //console.log(isAuthenticated, !inProgress);

  useEffect(() => {
    if (isAuthenticated && inProgress == "none") {
      // Check if language is available locally
      let languageFromStorage = localStorage.getItem("appLanguage");

      //console.log(languageFromStorage);

      if (languageFromStorage == undefined || languageFromStorage == null) {
        // Language not available locally, call API to get it
        // Example: fetchLanguageFromAPI().then(configObject => {...})
        const config = api.getUserConfig().then((response) => {
          console.log(response.data.object);
          let lang = response.data.object.language;

          if (lang == "en-GB" || lang == "en") {
            lang = "en";
            localStorage.setItem("appLanguage", lang);
          } else {
            lang = "de";
            localStorage.setItem("appLanguage", lang);
          }
          setLanguage(lang);
        });
      } else {
        // Language available locally, set the language using it
        setLanguage(languageFromStorage);
      }
    }
  }, [isAuthenticated, inProgress]);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("appLanguage", newLanguage);
    const payload = {
      language: newLanguage,
      colorScheme: "Light",
    };
    api.setUserConfig(payload);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  return useContext(LanguageContext);
};
